"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        panelMargins: (_a = {
                marginLeft: theme.spacing(4),
                marginRight: theme.spacing(4)
            },
            _a[theme.breakpoints.up('md')] = {
                marginLeft: 45,
                marginRight: 45,
            },
            _a),
    });
});
function DrawerMargin(_a) {
    var children = _a.children;
    var classes = useStyles();
    return react_1.default.createElement("div", { className: classes.panelMargins }, children);
}
exports.default = DrawerMargin;
